var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(!_vm.isAdmin())?[_c('Resume')]:_c('Dashboard')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }